
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-tim-kinerja/penilai/pelaksanaan/beranda",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-tim-kinerja/penilai/pelaksanaan/beranda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-tim-kinerja/penilai/pelaksanaan/beranda"])
      });
    }
  